import type {
    DocumentPartsResponse,
    InlineRelationsResponse,
} from "../types";
import type {PanelItem} from "./PanelContext";
import {PanelDocumentParts} from "./PanelDocumentParts";
import {PanelInlineRelations} from "./PanelInlineRelations";

export const PanelContent = ({item}: {item: PanelItem}) => {
    if (item.fetchType === "documentParts") {
        return (
            <PanelDocumentParts data={item.data as DocumentPartsResponse} />
        );
    }

    if (item.fetchType === "inlineRelations") {
        return (
            <PanelInlineRelations
                data={item.data as InlineRelationsResponse}
            />
        );
    }

    return null;
};
